/**
 * @generated SignedSource<<d8dead54a17fae821dd142cf8974f48d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProblemGeneratorDescriptionList_problemGenerator$data = {
  readonly assigned: any | null;
  readonly assignedTo: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
  } | null;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProblemGeneratorStatusLabel_problemGenerator">;
  readonly " $fragmentType": "ProblemGeneratorDescriptionList_problemGenerator";
};
export type ProblemGeneratorDescriptionList_problemGenerator$key = {
  readonly " $data"?: ProblemGeneratorDescriptionList_problemGenerator$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProblemGeneratorDescriptionList_problemGenerator">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProblemGeneratorDescriptionList_problemGenerator",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assigned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "assignedTo",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatarText_user"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProblemGeneratorStatusLabel_problemGenerator"
    }
  ],
  "type": "ProblemGenerator",
  "abstractKey": null
};
})();

(node as any).hash = "72eb4a381fd2430f70ca3922d444e324";

export default node;
